import { render, staticRenderFns } from "./AgendarPratica.vue?vue&type=template&id=43a9a97a&scoped=true"
import script from "./AgendarPratica.vue?vue&type=script&lang=js"
export * from "./AgendarPratica.vue?vue&type=script&lang=js"
import style0 from "./AgendarPratica.vue?vue&type=style&index=0&id=43a9a97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a9a97a",
  null
  
)

export default component.exports